export const getFieldInputSx = (theme) => ({
  borderRadius: Math.max(8, Math.round((theme?.shape?.borderRadius || 12) * 0.9)),
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(18,30,47,0.82)"
      : "rgba(255,255,255,0.96)",
  boxShadow: "inset 0 1px 1px rgba(255,255,255,0.08)",
});

export const getFieldLabelSx = (theme) => ({
  color: theme.palette.text.secondary,
  [`&.Mui-focused`]: {
    color: theme.palette.primary.main,
  },
});

export const getFormContainerSx = (theme, elevated = false) => ({
  mt: 0,
  p: 1,
  pb: 0,
  minWidth: "30vw",
  maxWidth: "100%",
  borderRadius: elevated
    ? Math.max(10, Math.round((theme?.shape?.borderRadius || 12) * 1.05))
    : 0,
  backgroundColor: elevated
    ? theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.04)"
      : "rgba(17,36,61,0.04)"
    : "transparent",
  boxShadow: elevated ? "0 6px 16px rgba(0,0,0,0.12)" : "none",
});
